<div
  class="card mb-2 article-card"
  [ngClass]="{ 'upcoming-card': type === 'upcoming' }"
>
  <div class="text-decoration-none text-dark">
    <div class="shadow-sm rounded position-relative">
      <div class="position-relative">
        <img
          [src]="hotel?.cdnUrl"
          [alt]="hotel?.altTag"
          class="img-fluid rounded"
          style="height: 210px; object-fit: cover; width: 100%"
        />
      </div>
      <div class="text-start content-container">
        <div class="d-flex align-items-center mb-0 location-text gap-2">
          <i class="fa fa-location-dot location-icon"></i>
          {{ hotel?.destination }}
        </div>
      </div>
    </div>
  </div>
</div>
